import { render, staticRenderFns } from "./section-password.vue?vue&type=template&id=6cf44a9c&scoped=true&"
import script from "./section-password.vue?vue&type=script&lang=js&"
export * from "./section-password.vue?vue&type=script&lang=js&"
import style0 from "./section-password.vue?vue&type=style&index=0&id=6cf44a9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf44a9c",
  null
  
)

export default component.exports